import React, { useEffect, useState } from 'react';
import { ChevronDown } from 'lucide-react';
import TarihGirisi from './TarihGirisi';

const kesenSebepTipleri = [
  'Şüpheli veya sanıklardan birinin savcı huzurunda ifadesinin alınması veya sorguya çekilmesi',
  'Şüpheli veya sanıklardan biri hakkında tutuklama kararının verilmesi',
  'Suçla ilgili olarak iddianame düzenlenmesi',
  'Sanıklardan bir kısmı hakkında da olsa, mahkûmiyet kararı verilmesi',
];

const bosSebep = () => ({ tip: '', tarih: new Date(), aciklama: '' });

function KesenSebepModal({ acik, kapat, kaydet, mevcut }) {
  const [sebep, setSebep] = useState(bosSebep);
  const duzenleme = Boolean(mevcut);

  useEffect(() => {
    if (acik) {
      setSebep(mevcut ? { ...mevcut, tarih: new Date(mevcut.tarih) } : bosSebep());
    }
  }, [acik, mevcut]);

  if (!acik) return null;

  const kaydedilebilir = Boolean(sebep.tip && sebep.tarih);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 p-4">
      <div className="w-full max-w-md rounded-xl border border-slate-200 bg-white shadow-2xl">
        <div className="border-b border-slate-100 px-5 py-4">
          <p className="text-[11px] font-semibold uppercase tracking-wider text-emerald-600">
            TCK 67/2 · Kesilme
          </p>
          <h2 className="text-lg font-semibold text-slate-800">
            {duzenleme ? 'Kesen sebebi düzenle' : 'Kesen sebep ekle'}
          </h2>
          <p className="mt-0.5 text-xs text-slate-500">Süreyi keser ve son kesme tarihinden yeniden başlatır.</p>
        </div>

        <div className="space-y-4 px-5 py-5">
          <div>
            <label className="mb-1.5 block text-sm font-medium text-slate-700">Sebep</label>
            <div className="relative">
              <select
                value={sebep.tip}
                onChange={(e) => setSebep({ ...sebep, tip: e.target.value })}
                className="w-full appearance-none rounded-lg border border-slate-300 bg-white px-3 py-2.5 pr-9 text-sm text-slate-900 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30"
              >
                <option value="">Sebep seçiniz…</option>
                {kesenSebepTipleri.map((tip) => (
                  <option key={tip} value={tip}>
                    {tip}
                  </option>
                ))}
              </select>
              <ChevronDown className="pointer-events-none absolute right-2.5 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
            </div>
          </div>

          <TarihGirisi
            label="Tarih"
            value={sebep.tarih}
            onChange={(date) => setSebep({ ...sebep, tarih: date })}
          />

          <div>
            <label className="mb-1.5 block text-sm font-medium text-slate-700">Açıklama (opsiyonel)</label>
            <input
              type="text"
              placeholder="Örn. dosya / karar numarası"
              value={sebep.aciklama}
              onChange={(e) => setSebep({ ...sebep, aciklama: e.target.value })}
              className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2.5 text-sm text-slate-900 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30"
            />
          </div>
        </div>

        <div className="flex justify-end gap-2 border-t border-slate-100 px-5 py-4">
          <button
            type="button"
            onClick={kapat}
            className="rounded-lg border border-slate-300 bg-white px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50"
          >
            İptal
          </button>
          <button
            type="button"
            disabled={!kaydedilebilir}
            onClick={() => kaydet(sebep)}
            className="rounded-lg bg-indigo-600 px-4 py-2 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-indigo-700 disabled:cursor-not-allowed disabled:opacity-40"
          >
            {duzenleme ? 'Kaydet' : 'Ekle'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default KesenSebepModal;
